// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"3ce86cc8","146":"70c4e083","449":"dab6d3b1","783":"72bdfeb0"}[chunkId] + ".chunk.js";
};